import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { DocumentTypesComponent } from './document-types.component'
import { CreateDocumentTypeComponent } from './create-document-type/create-document-type.component'
import { UpdateDocumentTypeComponent } from './update-document-type/update-document-type.component'
import { documentTypesRoutes } from './document-types.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    DocumentTypesComponent,
    CreateDocumentTypeComponent,
    UpdateDocumentTypeComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(documentTypesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    DocumentTypesComponent,
    CreateDocumentTypeComponent,
    UpdateDocumentTypeComponent,
  ],
})
export class DocumentTypesModule {}
